module.exports = __webpack_public_path__ + "cdf2671b8be0d7c640c04a05439c5136.png";